<template>
  <van-dialog
    v-model="dialogVisible"
    :show-confirm-button="false"
    width="325px"
    :close-on-click-overlay="true"
    class="custom-dialog"
  >
    <div class="youlike-container">
      <img class="youlike-icon" src="@/assets/images/ic_hobby_0.png" alt="" />
      <div class="title">
        <h1>猜你喜欢</h1>
        <div class="color-box"></div>
      </div>
      <div class="like-desc">请选择您感兴趣的游戏类型吧～</div>

      <div class="like-type">
        <div
          :class="[
            'like-type-item',
            currentIndex == item.itemCode ? 'like-type-item-actived' : '',
          ]"
          v-for="(item, i) in likeCartoryList"
          :key="i"
          @click="currentIndex = item.itemCode"
        >
          <img
            :src="currentIndex == item.itemCode ? item.activeIcon : item.icon"
            alt=""
          />
          <span>{{ item.label }}</span>
        </div>
      </div>

      <div
        :class="['chose-btn', currentIndex ? 'chosed-btn' : '']"
        @click="setUserLike"
      >
        我选好了
      </div>
      <img
        @click="dialogVisible = false"
        class="dialog-close"
        src="@/assets/images/dialog-close.png"
        alt=""
      />
    </div>
  </van-dialog>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    userLikes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      likeCartoryList: [
        {
          icon: require("@/assets/images/ic_hobby_1_grey.png"),
          activeIcon: require("@/assets/images/ic_hobby_1_ok.png"),
          itemCode: "LEGEND_TYPE",
          label: "传奇",
        },
        {
          icon: require("@/assets/images/ic_hobby_2_grey.png"),
          activeIcon: require("@/assets/images/ic_hobby_2_ok.png"),
          itemCode: "CARDS",
          label: "卡牌",
        },
        {
          icon: require("@/assets/images/ic_hobby_3_grey.png"),
          activeIcon: require("@/assets/images/ic_hobby_3_ok.png"),
          itemCode: "ROLE",
          label: "角色",
        },
        {
          icon: require("@/assets/images/ic_hobby_4_grey.png"),
          activeIcon: require("@/assets/images/ic_hobby_4_ok.png"),
          itemCode: "ALL",
          label: "都喜欢",
        },
      ],
      currentIndex: "",
    };
  },
  computed: {
    ...mapGetters(["uuid"]),
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
    if (this.userLikes.length) {
      this.currentIndex = this.userLikes[0].gameType;
    }
  },
  methods: {
    /**
     * 设置用户喜好
     */
    async setUserLike() {
      console.log("111");
      if (!this.currentIndex) {
        return;
      }
      try {
        await requestMethods("/modules/web/game/setUserLike.htm", "post", {
          uuid: this.uuid,
          gameTypes: this.currentIndex,
        });
        this.$toast("设置成功！");
        this.$emit("setUserLikeEvent");
        this.dialogVisible = false;
      } catch (err) {
        this.$toast(err.message);
      }
    },
  },
};
</script>

<style lang="scss">
.custom-dialog,
.van-dialog__content {
  overflow: visible; /* 允许内容超出 */
}
.youlike-container {
  background: #ffffff;
  box-shadow: inset 0px 1px 3px 0px #868a53;
  border-radius: 24px;
  height: 930px;
  text-align: center;

  .youlike-icon {
    width: 265px;
    margin-top: -50px;
  }
  .dialog-close {
    width: 60px;
    margin-top: 130px;
  }
  .title {
    text-align: center;
    h1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 40px;
      color: #000000;
    }
    .color-box {
      display: block;
      margin: 0 auto;
      width: 200px;
      height: 18px;
      background: linear-gradient(
        270deg,
        rgba(255, 255, 255, 0.25) 0%,
        #ffe5d7 100%
      );
      border-radius: 9px;
      margin-top: -6px;
    }
  }
  .like-desc {
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #000000;
    margin-top: 47px;
  }
  .like-type {
    display: flex;
    flex-direction: column; /* 垂直排列 */
    align-items: center; /* 水平居中 */
    width: 650px;
    margin-top: 70px;

    .like-type-item {
      width: 400px;
      height: 80px;
      border-radius: 40px;
      background: #f4f4f4;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #9d9d9d;
      }
      img {
        width: 50px;
        height: 50px;
        margin-right: 20px;
      }
    }
    .like-type-item-actived {
      background: #ffefe6;

      span {
        color: #ff8441;
      }
    }
  }

  .chose-btn {
    margin: 0 auto;
    width: 400px;
    height: 80px;
    background: #9d9d9d;
    color: #fff;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    border-radius: 40px;
    line-height: 80px;
    margin-top: 74px;
  }
  .chosed-btn {
    background: #ff8441;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/youLikeDialog.vue